<app-report-shell
  [user]="user"
  [currentTime]="''"
  [sidebarCollapsed]="sidebarCollapsed"
  [mobileSidebarOpen]="mobileSidebarOpen"
  (menuToggle)="handleMenuToggle()"
  (closeMobileSidebar)="closeMobileSidebar()"
>
  <main class="data-validation-page">
    <section class="data-validation-page__panel app-card">
      <div class="data-validation-page__panel-header">
        <div class="data-validation-page__heading-copy">
          <h2 class="app-title-serif">Data Validation</h2>
          <p>{{ monthLabel || getMonthDisplayLabel() }}</p>
        </div>
        <form class="data-validation-filters" [formGroup]="filtersForm">
          <div class="data-validation-filters__layout">
            <section class="data-validation-stats-card data-validation-filters-card" aria-label="Filters">
              <div class="data-validation-filters-card__body">
                <div class="data-validation-filters-card__fields">
                  <div class="app-form-field data-validation-filters__field">
                    <span class="app-form-label">Month / Year</span>
                    <div class="data-validation-filters__month-shell">
                      <select class="app-form-select data-validation-filters__month-select" [formControl]="monthNameControl" (change)="onFilterSelectionChange()">
                        @for (m of monthOptions; track m.value) {
                          <option [ngValue]="m.value">{{ m.label }}</option>
                        }
                      </select>
                      <select class="app-form-select data-validation-filters__year-select" [formControl]="yearControl" (change)="onFilterSelectionChange()">
                        @for (y of yearOptions; track y) {
                          <option [ngValue]="y">{{ y }}</option>
                        }
                      </select>
                    </div>
                  </div>
                  
                  <div class="app-form-field data-validation-filters__field">
                    <span class="app-form-label">Availability</span>
                    <select class="app-form-select" [formControl]="availabilityControl" (change)="onFilterSelectionChange()">
                      @for (option of availabilityOptions; track option.value) {
                        <option [ngValue]="option.value">{{ option.label }}</option>
                      }
                    </select>
                  </div>
                  <div class="app-form-field data-validation-filters__field">
                    <span class="app-form-label">Data Error</span>
                    <select class="app-form-select" [formControl]="dataErrorControl" (change)="onFilterSelectionChange()">
                      @for (option of dataErrorOptions; track option.value) {
                        <option [ngValue]="option.value">{{ option.label }}</option>
                      }
                    </select>
                  </div>
                  <div class="app-form-field data-validation-filters__field">
                    <span class="app-form-label">Owner</span>
                    <select class="app-form-select" formControlName="owner" (change)="onFilterSelectionChange()">
                      @for (option of ownerOptions; track option.value) {
                        <option [value]="option.value">{{ option.label }}</option>
                      }
                    </select>
                  </div>
                  <div class="app-form-field data-validation-filters__field">
                    <span class="app-form-label">Select Generator</span>
                    <div class="data-validation-filters__select-shell">
                      <p-autocomplete
                        [(ngModel)]="substationSearchTerm"
                        [ngModelOptions]="{ standalone: true }"
                        [dropdown]="true"
                        [suggestions]="filteredSubstationOptions"
                        placeholder="Select Generator"
                        (completeMethod)="onSubstationSearchInput($event)"
                        (fieldBlur)="onSubstationSearchBlur()"
                      
                      ></p-autocomplete>
                    </div>
                  </div>

                  <div class="app-filter-actions data-validation-filters__clear">
                    <button
                      type="button"
                      class="app-button app-button--secondary equal app-filter-actions__button"
                      [disabled]="isLoading"
                      (click)="clearFilters()"
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </form>
      </div>

      <div class="data-validation-page__panel-body">
            <div class="data-validation-summary-cards">
            <div class="data-validation-monthly-summary">
            <section class="data-validation-stats-card" aria-label="Monthly stats">
              <div class="data-validation-stats-card__header">
                {{ monthlyStatsTitlePrefix }}<span class="data-validation-stats-card__date">{{ monthlyStatsDateLabel }}</span>)
              </div>
              <div class="data-validation-stats-card__sections">
                @for (status of summaryStatusOrder; track status) {
                  <div class="data-validation-stats-card__section data-validation-stats-card__section--{{ status.toLowerCase() }}">
                    <span class="data-validation-stats-card__label">{{ status }}</span>
                    <span class="data-validation-stats-card__value">{{ monthlyStats[status] }}</span>
                  </div>
                }
              </div>
            </section>
            <div class="data-validation-last-sync">
              <span class="data-validation-last-sync__icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" focusable="false">
                  <path d="M20 11a8 8 0 0 0-14.7-4.2L3 9m0 0V4m0 5h5M4 13a8 8 0 0 0 14.7 4.2L21 15m0 0v5m0-5h-5" />
                </svg>
              </span>
              <span>Latest File Sync Datetime:</span>
              <strong>{{ lastSyncFileDatetimeDisplay }}</strong>
            </div>
            </div>

            <section class="data-validation-stats-card" aria-label="Daily stats">
              <div class="data-validation-stats-card__header">
                {{ dailyStatsTitlePrefix }}<span class="data-validation-stats-card__date">{{ dailyStatsDateLabel }}</span>)
              </div>
              <div class="data-validation-stats-card__sections">
                @for (status of summaryStatusOrder; track status) {
                  <div class="data-validation-stats-card__section data-validation-stats-card__section--{{ status.toLowerCase() }}">
                    <span class="data-validation-stats-card__label">{{ status }}</span>
                    <span class="data-validation-stats-card__value">{{ dailyStats[status] }}</span>
                  </div>
                }
              </div>
            </section>

            <section class="data-validation-stats-card" aria-label="Data verification">
              <div class="data-validation-stats-card__header">{{ dataVerificationTitle }}</div>
              <div class="data-validation-stats-card__sections">
                @for (metric of verificationStatsSections; track metric.key) {
                  <div class="data-validation-stats-card__section data-validation-stats-card__section--verification">
                    <span class="data-validation-stats-card__label">{{ metric.label }}</span>
                    <span class="data-validation-stats-card__value">
                      {{ formatVerificationValue(getVerificationMetricValue(metric.key), metric.suffix) }}
                    </span>
                  </div>
                }
              </div>
            </section>
          </div>

        <div class="data-validation-page__table-wrap app-table-scroll">
          <table class="data-validation-table">
            <colgroup>
    <col class="data-validation-table__col--sticky" />
    @for (day of days; track trackByDay($index, day)) {
      <col class="data-validation-table__col--day" />
    }
  </colgroup>
            <thead>
              <tr>
                <th class="data-validation-table__sticky-column generator" scope="col">Generator / Day</th>
                @for (day of days; track trackByDay($index, day)) {
                  <th scope="col" [ngClass]="getDayHeaderClass(day)">
                    {{ formatDayHeaderLabel(day) }}
                  </th>
                }
              </tr>
            </thead>
            <tbody>
              @if (isLoading) {
                <tr>
                  <td [attr.colspan]="getEmptyStateColspan()" class="data-validation-page__empty-state">Loading data validation data...</td>
                </tr>
              } @else if (filteredRows.length) {
                @for (station of filteredRows; track trackByStation($index, station)) {
                  <tr class="data-validation-table__station-row">
                    <th class="data-validation-table__sticky-column" scope="row">
                    
                      <div class="data-validation-table__station-label">
  <div class="data-validation-table__station-heading">
    <div class="serialno">{{ station.serial_no }}.</div>
    
    <button
      type="button"
      class="data-validation-table__station-name-button"
      [attr.title]="station.station_name"
      [attr.aria-label]="station.station_name"
      (click)="openScadaDetailsModal(station)"
    >
      <strong>{{ station.station_name }}</strong>
    </button>
    <span
      [class]="getCurrentBlockBadgeClass(station)"
      [attr.title]="getCurrentBlockBadgeTitle(station)"
      [attr.aria-label]="getCurrentBlockBadgeTitle(station)"
    ></span>
  </div>
  <div class="data-validation-table__last-sync">
    Last Sync On: {{ station.last_sync_on_label || 'N/A' }}
  </div>
</div>
                    </th>
                    @for (cell of station.cells; track cell.day) {
                    
                      <td
                        class="data-validation-table__day-cell"
                        [class.data-validation-table__day-cell--today]="cell.day === getCurrentDayOfMonth()"
                      >
  @if (shouldShowAvailabilityCell(cell)) {
    <button
      type="button"
      class="data-validation-table__status-button"
      [ngClass]="{
        'data-validation-table__status-button--fa': cell.status === 'FA',
        'data-validation-table__status-button--pa': cell.status === 'PA',
        'data-validation-table__status-button--na': cell.status === 'NA',
        'data-validation-table__status-button--active': isCellExpanded(station, cell)
      }"
      [attr.title]="getCellTitle(cell)"
      [attr.aria-label]="getCellTitle(cell)"
      (click)="toggleCell(station, cell)"
    >
      <span class="data-validation-table__status-code">{{ cell.status }}</span>
    </button>
  }
</td>
                    }
                  </tr>

                  @if (getExpandedCellForRow(station); as expandedCell) {
                    <tr class="data-validation-table__accordion-row">
                      <td [attr.colspan]="getMatrixColspan()">
  <div class="data-validation-accordion__cell-shrink">
    <div class="data-validation-accordion">
      <div class="data-validation-accordion__header">
        <div class="data-validation-accordion__heading">
          <p>{{ getAccordionLabel(expandedCell) }}</p>
        </div>
      </div>

      <div class="data-validation-accordion__table-wrap app-table-scroll app-scrollbar-x">
        <table class="data-validation-detail-table log-sheet-table">
          <thead>
            <tr>
              <th scope="col" class="data-validation-detail-table__label-column">Block</th>
              @for (block of blocks; track trackByBlock($index, block)) {
                <th
                  scope="col"
                  [class]="'log-sheet-table__hour-cell log-sheet-table__hour-cell--' + block.period"
                  [class.data-validation-detail-table__block-cell--current]="isCurrentBlockHour(block.block_no)"
                >
                  {{ block.label }}
                </th>
              }
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row" class="data-validation-detail-table__label-column">Value</th>
              @for (block of blocks; track trackByBlock($index, block)) {
                <td
                  [class]="'log-sheet-table__hour-cell log-sheet-table__hour-cell--' + block.period"
                  [class.data-validation-detail-table__block-cell--current]="isCurrentBlockHour(block.block_no)"
                  [ngClass]="getBlockVariationClasses(station, expandedCell, block.block_no)"
                >
                  @if (getBlockVariationTooltip(station, expandedCell, block.block_no)) {
                    <app-custom-tooltip
                      class="data-validation-detail-table__variation-tooltip"
                      [text]="getAccordionValue(expandedCell, block.block_no)"
                      [tooltipText]="getBlockVariationTooltip(station, expandedCell, block.block_no)"
                      [maxLength]="999"
                      [showTooltipOnHover]="true"
                    ></app-custom-tooltip>
                  } @else {
                    <span class="log-sheet-table__cell-text">{{ getAccordionValue(expandedCell, block.block_no) }}</span>
                  }
                </td>
              }
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</td>
                    </tr>
                  }
                }
              } @else {
                <tr>
                  <td [attr.colspan]="getEmptyStateColspan()" class="data-validation-page__empty-state">
                    No data validation records found for the selected month
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        <div class="data-validation-page__footer">
          <div class="data-validation-page__legend" aria-label="Availability legend">
            <span class="data-validation-page__legend-item">
              <span class="data-validation-page__legend-swatch data-validation-page__legend-swatch--current" aria-hidden="true"></span>
              <span>Current Block</span>
            </span>
            <span class="data-validation-page__legend-item">
              <span class="data-validation-page__legend-swatch data-validation-page__legend-swatch--fa" aria-hidden="true"></span>
            <span>FA - Full Available</span>
            </span>
            <span class="data-validation-page__legend-item">
              <span class="data-validation-page__legend-swatch data-validation-page__legend-swatch--pa" aria-hidden="true"></span>
              <span>PA - Partial Available</span>
            </span>
            <span class="data-validation-page__legend-item">
              <span class="data-validation-page__legend-swatch data-validation-page__legend-swatch--na" aria-hidden="true"></span>
              <span>NA - Not Available</span>
            </span>
            <span class="data-validation-page__legend-item">
              <span class="data-validation-page__legend-swatch data-validation-page__legend-swatch--error-low" aria-hidden="true"></span>
              <span>Low Variation (1-{{ lowVariationThreshold }}%)</span>
            </span>
            <span class="data-validation-page__legend-item">
              <span class="data-validation-page__legend-swatch data-validation-page__legend-swatch--error-medium" aria-hidden="true"></span>
              <span>Medium Variation ({{ lowVariationThreshold }}-{{ mediumVariationThreshold }}%)</span>
            </span>
            <span class="data-validation-page__legend-item">
              <span class="data-validation-page__legend-swatch data-validation-page__legend-swatch--error-high" aria-hidden="true"></span>
              <span>High Variation (&gt; {{ mediumVariationThreshold }}%)</span>
            </span>
          </div>

          @if (canShowPagination()) {
            <div class="data-validation-page__pagination">
              <div class="data-validation-page__pagination-summary">
                <span>{{ getPaginationLabel() }}</span>
              </div>

              <div class="data-validation-page__pagination-actions">
                <button
                  type="button"
                  class="app-button app-button--secondary data-validation-page__pagination-button"
                  [disabled]="pagination.page_no <= 1 || isLoading"
                  (click)="goToPreviousPage()"
                >
                  Previous
                </button>

                <div class="data-validation-page__pagination-pages" aria-label="Pagination pages">
                  @for (page of getPaginationItems(); track $index) {
                    @if (page === -1) {
                      <span class="data-validation-page__pagination-ellipsis" aria-hidden="true">...</span>
                    } @else {
                      <button
                        type="button"
                        class="data-validation-page__pagination-page"
                        [class.data-validation-page__pagination-page--active]="pagination.page_no === page"
                        [disabled]="isLoading"
                        (click)="goToPage(page)"
                      >
                        {{ page }}
                      </button>
                    }
                  }
                </div>

                <button
                  type="button"
                  class="app-button app-button--secondary data-validation-page__pagination-button"
                  [disabled]="pagination.page_no >= pagination.total_pages || isLoading || pagination.total_pages === 0"
                  (click)="goToNextPage()"
                >
                  Next
                </button>
              </div>

              <label class="data-validation-page__pagination-size">
                <span class="data-validation-page__pagination-size-label">Rows per page</span>
                <select class="app-form-select data-validation-page__pagination-select" [formControl]="pageSizeControl">
                  @for (size of pageSizeOptions; track size) {
                    <option [ngValue]="size">{{ size }}/Page</option>
                  }
                </select>
              </label>
            </div>
          }
        </div>
      </div>
    </section>
  </main>
</app-report-shell>

@if (scadaDetailsModalOpen) {
  <div class="app-modal-backdrop data-validation-scada-modal-backdrop">
    <dialog class="app-modal data-validation-scada-modal" open>
      <div class="data-validation-scada-modal__header">
        <div>
          <h3 class="app-title-serif">SCADA Data Details</h3>
          <p class="data-validation-scada-modal__subtitle">File timestamp-wise generator readings</p>
        </div>
        <div class="data-validation-scada-modal__header-actions">
          <button
            type="button"
            class="app-button app-button--secondary"
            [disabled]="scadaDetailsExporting || !selectedScadaGeneratorIds.length"
            (click)="exportScadaDetails()"
          >
            {{ scadaDetailsExporting ? 'Exporting...' : 'Export Excel' }}
          </button>
          <button type="button" class="app-button app-button--icon" aria-label="Close SCADA details" (click)="closeScadaDetailsModal()">×</button>
        </div>
      </div>

      <div class="data-validation-scada-modal__filters">
        <label class="app-form-field">
          <span class="app-form-label">Date</span>
          @if (isBsDateMode) {
            <div class="app-form-input data-validation-scada-modal__date-display">{{ scadaDetailsDateLabel }}</div>
          } @else {
            <input class="app-form-input" type="date" [(ngModel)]="scadaDetailsDate" (change)="onScadaDetailsFilterChange()" />
          }
        </label>
        <label class="app-form-field">
          <span class="app-form-label">Parameter</span>
          <select class="app-form-select" [(ngModel)]="scadaDetailsParameter" (change)="onScadaDetailsFilterChange()">
            @for (option of scadaParameterOptions; track option.value) {
              <option [value]="option.value">{{ option.label }}</option>
            }
          </select>
        </label>
        <div class="app-form-field data-validation-scada-modal__generator-filter">
          <span class="app-form-label">Generators</span>
          <p-autocomplete
            [(ngModel)]="scadaDetailsGeneratorSearchTerm"
            [ngModelOptions]="{ standalone: true }"
            [dropdown]="true"
            [suggestions]="filteredScadaDetailsGenerators"
            [showSuggestionCheckbox]="true"
            [selectedSuggestionIds]="selectedScadaGeneratorIds"
            [selectedSuggestions]="selectedScadaDetailsGeneratorOptions"
            placeholder="Search generators"
            (completeMethod)="onScadaDetailsGeneratorSearch($event)"
          ></p-autocomplete>
        </div>
        <div class="app-form-field data-validation-scada-modal__clear-filter">
          <span class="app-form-label">&nbsp;</span>
          <button type="button" class="app-button app-button--secondary data-validation-scada-modal__clear-button" (click)="clearScadaDetailsFilters()">Clear</button>
        </div>
      </div>

      <div #scadaDetailsTableWrap class="data-validation-scada-modal__table-wrap" (scroll)="onScadaDetailsScroll($event)">
        <table class="data-validation-scada-table">
          <thead>
            <tr>
              <th rowspan="2" scope="col">S. No.</th>
              <th rowspan="2" scope="col">
                <button type="button" class="data-validation-scada-table__sort-button" (click)="toggleScadaDetailsSort()">
                  Scada File Datetime
                  <span aria-hidden="true">{{ scadaDetailsSortOrder === 'asc' ? '▲' : '▼' }}</span>
                </button>
              </th>
              @for (generator of scadaDetailsGenerators; track generator.id) {
                @if (isScadaDetailsGeneratorSelected(generator.id)) {
                  <th colspan="3" scope="colgroup" class="data-validation-scada-table__group-start data-validation-scada-table__group-end">{{ getScadaDetailsGeneratorLabel(generator) }}</th>
                }
              }
            </tr>
            <tr>
              @for (generator of scadaDetailsGenerators; track generator.id) {
                @if (isScadaDetailsGeneratorSelected(generator.id)) {
                  <th scope="col" class="data-validation-scada-table__group-start ">Data Value</th>
                  <th scope="col" class="data-validation-scada-table__group-start">Data Timestamp</th>
                  <th scope="col" class="data-validation-scada-table__group-end ">Anomaly</th>
                }
              }
            </tr>
          </thead>
          <tbody>
            @for (row of scadaDetailsRows; track row.file_datetime) {
              <tr>
                <td>{{ $index + 1 }}</td>
                <td>{{ formatScadaTimestamp(row.file_datetime) }}</td>
                @for (generator of scadaDetailsGenerators; track generator.id) {
                  @if (isScadaDetailsGeneratorSelected(generator.id)) {
                    <td class="data-validation-scada-table__group-start border-left" [class.data-validation-scada-table__anomaly-cell]="isScadaDetailsAnomaly(row, generator.id)">{{ getScadaDetailsValue(row, generator.id) ?? '-' }}</td>
                    <td [class.data-validation-scada-table__anomaly-cell]="isScadaDetailsAnomaly(row, generator.id)">{{ getScadaDetailsTimestamp(row, generator.id) }}</td>
                    <td class="data-validation-scada-table__group-end border-right">{{ isScadaDetailsAnomaly(row, generator.id) ? 'Yes' : 'No' }}</td>
                  }
                }
              </tr>
            }
            @if (scadaDetailsLoading && !scadaDetailsRows.length) {
              <tr><td [attr.colspan]="2 + selectedScadaGeneratorIds.length * 3">Loading SCADA details...</td></tr>
            } @else if (!scadaDetailsLoading && !scadaDetailsRows.length) {
              <tr><td [attr.colspan]="2 + selectedScadaGeneratorIds.length * 3">No SCADA data found for the selected filters.</td></tr>
            }
          </tbody>
        </table>
        @if (scadaDetailsLoading && scadaDetailsRows.length) {
          <div class="data-validation-scada-modal__loading-more">Loading more records...</div>
        }
      </div>
    </dialog>
  </div>
}
